import React from 'react';
import './gene.css';

function AboutPage() {
    return (
        <div className="gene-page">
            {/* Sidebar */}
            <div className="gene-sidebar">
                <h1 className="gene-sidebar-title">About</h1>
                
                <div className="gene-sidebar-section">
                    <p className="gene-sidebar-label">Platform</p>
                    <div style={{ 
                        padding: '0.75rem 1rem', 
                        background: 'rgba(255, 255, 255, 0.6)', 
                        border: '1px solid rgba(0, 0, 0, 0.1)', 
                        borderRadius: '8px',
                        fontSize: '0.875rem',
                        color: '#374151'
                    }}>
                        <div style={{ fontWeight: '600', marginBottom: '4px' }}>WBT Atlas</div>
                        <div style={{ fontSize: '0.75rem', color: '#6b7280' }}>Web-based Transcriptomics</div>
                    </div>
                </div>

                <div className="gene-sidebar-section">
                    <p className="gene-sidebar-label">Technology Stack</p>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        <div style={{ 
                            padding: '6px 10px', 
                            background: 'rgba(59, 130, 246, 0.1)', 
                            borderRadius: '12px',
                            fontSize: '0.75rem',
                            color: '#1e40af',
                            textAlign: 'center'
                        }}>React</div>
                        <div style={{ 
                            padding: '6px 10px', 
                            background: 'rgba(16, 185, 129, 0.1)', 
                            borderRadius: '12px',
                            fontSize: '0.75rem',
                            color: '#047857',
                            textAlign: 'center'
                        }}>Node.js</div>
                        <div style={{ 
                            padding: '6px 10px', 
                            background: 'rgba(245, 158, 11, 0.1)', 
                            borderRadius: '12px',
                            fontSize: '0.75rem',
                            color: '#92400e',
                            textAlign: 'center'
                        }}>Plotly.js</div>
                    </div>
                </div>

                <div className="gene-sidebar-section">
                    <p className="gene-sidebar-label">Usage</p>
                    <div style={{ 
                        padding: '0.75rem 1rem', 
                        background: 'rgba(239, 68, 68, 0.1)', 
                        border: '1px solid rgba(239, 68, 68, 0.2)', 
                        borderRadius: '8px',
                        fontSize: '0.75rem',
                        color: '#dc2626'
                    }}>
                        <div style={{ fontWeight: '600', marginBottom: '4px' }}>Academic Use Only</div>
                        <div>Non-commercial purposes</div>
                    </div>
                </div>
            </div>

            {/* Main Content */}
            <div className="gene-main-content">
                <div className="gene-content">
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                        
                        {/* Overview */}
                        <div className="gene-glass-card">
                            <div className="gene-card-title">
                                WBT Atlas Platform Overview
                                <span className="gene-tag">v2.0</span>
                            </div>
                            <p className="gene-card-subtitle">
                                A comprehensive web-based transcriptomics analysis platform
                            </p>
                            
                            <div style={{ marginTop: '16px', lineHeight: '1.6', color: '#374151' }}>
                                <p style={{ marginBottom: '12px' }}>
                                    Built using React and modern web technologies, this is a comprehensive recreation 
                                    of the original R Shiny WBT Atlas application. The platform provides an intuitive 
                                    interface for exploring complex genomic datasets with real-time visualizations 
                                    and interactive analysis tools.
                                </p>
                                <p style={{ marginBottom: '0' }}>
                                    Our high-performance Node.js backend is designed to handle large genomic datasets 
                                    efficiently, with advanced caching mechanisms for optimal performance and 
                                    responsive user experience.
                                </p>
                            </div>
                        </div>

                        {/* Analysis Features */}
                        <div className="gene-glass-card">
                            <div className="gene-card-title">
                                Analysis Capabilities
                                <span className="gene-tag">7 modules</span>
                            </div>
                            <p className="gene-card-subtitle">
                                Comprehensive genomic analysis tools and visualizations
                            </p>
                            
                            <div style={{ marginTop: '16px' }}>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                    <div style={{ padding: '12px', background: 'rgba(59, 130, 246, 0.05)', borderRadius: '8px', border: '1px solid rgba(59, 130, 246, 0.1)' }}>
                                        <div style={{ fontWeight: '600', color: '#1e40af', marginBottom: '4px', fontSize: '0.875rem' }}>🧬 Gene Signatures</div>
                                        <div style={{ fontSize: '0.75rem', color: '#6b7280' }}>Differential expression analysis across conditions</div>
                                    </div>
                                    
                                    <div style={{ padding: '12px', background: 'rgba(16, 185, 129, 0.05)', borderRadius: '8px', border: '1px solid rgba(16, 185, 129, 0.1)' }}>
                                        <div style={{ fontWeight: '600', color: '#047857', marginBottom: '4px', fontSize: '0.875rem' }}>🛤️ Pathway Enrichment</div>
                                        <div style={{ fontSize: '0.75rem', color: '#6b7280' }}>GSEA and pathway analysis across diseases</div>
                                    </div>
                                    
                                    <div style={{ padding: '12px', background: 'rgba(245, 158, 11, 0.05)', borderRadius: '8px', border: '1px solid rgba(245, 158, 11, 0.1)' }}>
                                        <div style={{ fontWeight: '600', color: '#92400e', marginBottom: '4px', fontSize: '0.875rem' }}>🔗 Co-Expression</div>
                                        <div style={{ fontSize: '0.75rem', color: '#6b7280' }}>Gene clusters and co-expression modules</div>
                                    </div>
                                    
                                    <div style={{ padding: '12px', background: 'rgba(168, 85, 247, 0.05)', borderRadius: '8px', border: '1px solid rgba(168, 85, 247, 0.1)' }}>
                                        <div style={{ fontWeight: '600', color: '#7c3aed', marginBottom: '4px', fontSize: '0.875rem' }}>⏳ Aging Signatures</div>
                                        <div style={{ fontSize: '0.75rem', color: '#6b7280' }}>Age-related expression correlations</div>
                                    </div>
                                    
                                    <div style={{ padding: '12px', background: 'rgba(239, 68, 68, 0.05)', borderRadius: '8px', border: '1px solid rgba(239, 68, 68, 0.1)' }}>
                                        <div style={{ fontWeight: '600', color: '#dc2626', marginBottom: '4px', fontSize: '0.875rem' }}>🛡️ Immune Profiling</div>
                                        <div style={{ fontSize: '0.75rem', color: '#6b7280' }}>Cell type proportions and diversity</div>
                                    </div>
                                    
                                    <div style={{ padding: '12px', background: 'rgba(6, 182, 212, 0.05)', borderRadius: '8px', border: '1px solid rgba(6, 182, 212, 0.1)' }}>
                                        <div style={{ fontWeight: '600', color: '#0891b2', marginBottom: '4px', fontSize: '0.875rem' }}>⚡ Metabolic Pathways</div>
                                        <div style={{ fontSize: '0.75rem', color: '#6b7280' }}>Metabolic activity and reaction analysis</div>
                                    </div>
                                </div>
                                
                                <div style={{ marginTop: '16px', padding: '12px', background: 'rgba(99, 102, 241, 0.05)', borderRadius: '8px', border: '1px solid rgba(99, 102, 241, 0.1)' }}>
                                    <div style={{ fontWeight: '600', color: '#4f46e5', marginBottom: '4px', fontSize: '0.875rem' }}>🎯 Disease Prediction</div>
                                    <div style={{ fontSize: '0.75rem', color: '#6b7280' }}>SHAP-based biomarker discovery and feature importance analysis</div>
                                </div>
                            </div>
                        </div>

                        {/* Technical Details */}
                        <div className="gene-glass-card">
                            <div className="gene-card-title">
                                Technical Architecture
                                <span className="gene-tag">Modern</span>
                            </div>
                            <p className="gene-card-subtitle">
                                Scalable, performant, and user-friendly design
                            </p>
                            
                            <div style={{ marginTop: '16px' }}>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                        <div style={{ 
                                            width: '8px', 
                                            height: '8px', 
                                            borderRadius: '50%', 
                                            background: '#3b82f6',
                                            flexShrink: 0
                                        }}></div>
                                        <div>
                                            <span style={{ fontWeight: '600', color: '#1f2937' }}>Frontend:</span>
                                            <span style={{ color: '#6b7280', marginLeft: '8px' }}>React 18 with modern hooks, responsive design, and real-time visualizations</span>
                                        </div>
                                    </div>
                                    
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                        <div style={{ 
                                            width: '8px', 
                                            height: '8px', 
                                            borderRadius: '50%', 
                                            background: '#10b981',
                                            flexShrink: 0
                                        }}></div>
                                        <div>
                                            <span style={{ fontWeight: '600', color: '#1f2937' }}>Backend:</span>
                                            <span style={{ color: '#6b7280', marginLeft: '8px' }}>High-performance Node.js with intelligent caching and data optimization</span>
                                        </div>
                                    </div>
                                    
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                        <div style={{ 
                                            width: '8px', 
                                            height: '8px', 
                                            borderRadius: '50%', 
                                            background: '#f59e0b',
                                            flexShrink: 0
                                        }}></div>
                                        <div>
                                            <span style={{ fontWeight: '600', color: '#1f2937' }}>Visualization:</span>
                                            <span style={{ color: '#6b7280', marginLeft: '8px' }}>Interactive Plotly.js charts with custom styling and responsive layouts</span>
                                        </div>
                                    </div>
                                    
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                        <div style={{ 
                                            width: '8px', 
                                            height: '8px', 
                                            borderRadius: '50%', 
                                            background: '#8b5cf6',
                                            flexShrink: 0
                                        }}></div>
                                        <div>
                                            <span style={{ fontWeight: '600', color: '#1f2937' }}>Performance:</span>
                                            <span style={{ color: '#6b7280', marginLeft: '8px' }}>Advanced memoization, lazy loading, and optimized data structures</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Usage & License */}
                        <div className="gene-glass-card">
                            <div className="gene-card-title">
                                Usage & Licensing
                                <span className="gene-tag">Important</span>
                            </div>
                            <p className="gene-card-subtitle">
                                Please review these terms before using the platform
                            </p>
                            
                            <div style={{ marginTop: '16px' }}>
                                <div style={{ 
                                    padding: '16px', 
                                    background: 'rgba(239, 68, 68, 0.05)', 
                                    border: '1px solid rgba(239, 68, 68, 0.2)', 
                                    borderRadius: '8px',
                                    marginBottom: '16px'
                                }}>
                                    <div style={{ 
                                        display: 'flex', 
                                        alignItems: 'center', 
                                        gap: '8px', 
                                        marginBottom: '8px'
                                    }}>
                                        <div style={{ fontSize: '16px' }}>⚠️</div>
                                        <span style={{ fontWeight: '600', color: '#dc2626' }}>Academic Use Only</span>
                                    </div>
                                    <p style={{ 
                                        margin: '0', 
                                        fontSize: '0.875rem', 
                                        color: '#7f1d1d', 
                                        lineHeight: '1.5'
                                    }}>
                                        The use of this web tool is limited to academic, non-commercial purposes only. 
                                        Commercial use, redistribution, or modification requires explicit permission.
                                    </p>
                                </div>
                                
                                <div style={{ fontSize: '0.875rem', color: '#6b7280', lineHeight: '1.6' }}>
                                    <p style={{ marginBottom: '8px' }}>
                                        This platform is provided for educational and research purposes. Please cite 
                                        our work if you use this tool in your research publications.
                                    </p>
                                    <p style={{ margin: '0' }}>
                                        For technical support, feature requests, or collaboration inquiries, 
                                        please contact the development team through the appropriate academic channels.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AboutPage;
